module.exports = __webpack_public_path__ + "img/icon-expert.15657fcb.svg";